module.exports = __webpack_public_path__ + "img/PAI_Landing-Page_Mobile_17.9b4f6fce.jpg";